import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import ReactDOM from 'react-dom';
import App from './App';
import { bootstrapTelemetry } from './telemetry/bootstrap';
import './index.css';

LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-084874}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{The_First_American_Financial_Corp}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Agentnet}_only_for_{4}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Agentnet}_need_to_be_licensed___{Agentnet}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{11_December_2026}____[v3]_[01]_MTc5Njk0NzIwMDAwMA==e5ed5d37d6dbd55e6e12e45b9acbf3ad',
);

bootstrapTelemetry();

ReactDOM.render(<App />, document.getElementById('root'));
